export default "__VITE_ASSET__0a274440__"